import React, { useState } from 'react';
import { Share2, AlertCircle, Check, Linkedin } from 'lucide-react';
import { shareOnLinkedIn } from '../lib/linkedin';
import { getCurrentUser } from '../lib/auth';

interface LinkedInShareButtonProps {
  content: string;
  className?: string;
}

const LinkedInShareButton: React.FC<LinkedInShareButtonProps> = ({ content, className = '' }) => {
  const [isSharing, setIsSharing] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleShare = async () => {
    const user = getCurrentUser();
    if (!user) {
      setError('Vous devez être connecté pour partager sur LinkedIn');
      return;
    }

    setIsSharing(true);
    setError(null);
    setSuccess(false);

    try {
      await shareOnLinkedIn(content);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (error: any) {
      setError(error.message || 'Erreur lors du partage sur LinkedIn');
      setTimeout(() => setError(null), 5000);
    } finally {
      setIsSharing(false);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={handleShare}
        disabled={isSharing}
        className={`flex items-center space-x-2 bg-[#0A66C2] text-white px-4 py-2 rounded-md hover:bg-[#004182] transition-colors disabled:opacity-50 ${className}`}
      >
        {isSharing ? (
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
        ) : (
          <>
            <Share2 className="w-5 h-5" />
            <span>Partager sur LinkedIn</span>
          </>
        )}
      </button>

      {error && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-red-50 text-red-600 p-2 rounded-md flex items-center text-sm">
          <AlertCircle className="w-4 h-4 mr-2 flex-shrink-0" />
          <span>{error}</span>
        </div>
      )}

      {success && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-green-50 text-green-600 p-2 rounded-md flex items-center text-sm">
          <Check className="w-4 h-4 mr-2 flex-shrink-0" />
          <span>Partagé avec succès sur LinkedIn !</span>
        </div>
      )}
    </div>
  );
};

export default LinkedInShareButton;